import { FC, useEffect, useRef } from 'react';
import { ActionTypes, IPrompt, ISource } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';

import { PromptView } from './Message/PromptView';
import './PromptList.scss';

export interface PromptListProps {
    prompts: IPrompt[];
    onUpdate: (actionType: ActionTypes, prompts: IPrompt[], updatedPromptIndex: number) => void;
    onUpdateAnsweredQuery: (updatedPromptIndex: number, newQuery: string) => void;
    onSourceClick: (source: ISource) => void;
}

// renders the list of messages
export const PromptList: FC<PromptListProps> = (props: PromptListProps) => {
    const { prompts, onUpdate, onUpdateAnsweredQuery, onSourceClick } = props;
    const promptList = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        if (promptList?.current) {
            promptList.current.scrollTop = promptList.current.scrollHeight;
        }
    }, [prompts]);
    return (
        <div className='promptList' ref={promptList}>
            {prompts.map((prompt, index) => (
                <PromptView
                    key={`prompt_${prompt.id}`}
                    prompt={prompt}
                    isLastPrompt={index===prompts.length-1}
                    onEditQuery={(query) => {
                        onUpdateAnsweredQuery(index, query);
                    }}
                    onUpdate={(actionType, newPrompt) => {
                        const newPrompts = [...prompts];
                        newPrompts[index] = newPrompt;
                        onUpdate(actionType, newPrompts, index);
                    }}
                    onSourceClick={onSourceClick}
                />
            ))}
        </div>
    );
};
